import React from 'react';
import styled from 'styled-components';
import { format } from 'date-fns';
import outboundLinkUrl from '../../images/outbound-link.svg';

const ArticleListContainer = styled.div`
  background: #fafafa;
  padding-bottom: 100px;
  border-bottom: 1px solid #ebebeb;
`;

const ArticleListInner = styled.div`
  max-width: 660px;
  padding: 0 25px;
  margin: 0 auto;
`;

const ArticleContainer = styled.div`
  margin-bottom: 10px;
  font-weight: 600;
  border-top: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: 1px solid #f0f0f0;
    padding-bottom: 10px;
    margin-bottom: 0;
  }
`;

const ArticleDate = styled.div`
  color: #999999;
  padding-top: 20px;
  font-size: 14px;
  line-height: 22px;
`;

const HeadlineLinkContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Headline = styled.div`
  padding-right: 8px;
  a {
    color: black;
    text-decoration: none;

    &:hover {
      color: #262626;
    }
  }
`;

// const LinkButtonContainer = styled.div`
//   position: relative;
//   margin-top: -16px;
//   img {
//     position: relative;
//     top: -4px;
//     width: 45px;
//   }
// `;

const LinkButtonContainer = styled.div`
  position: relative;
  top: -8px;
  margin-top: -8px;
  img {
    width: 45px;
  }
`;

function ArticleListSection({ input }) {
  function formatDate(date) {
    return format(new Date(date), 'MMMM D, YYYY');
  }

  return (
    <ArticleListContainer>
      <ArticleListInner>
        {input.items.map((item, i) => {
          return (
            <ArticleContainer key={i}>
              <ArticleDate>{item.source.text} - {formatDate(item.date)}</ArticleDate>
              <HeadlineLinkContainer>
                <Headline><a href={item.link.url} target="_blank" rel="noopener noreferrer">{item.headline.text}</a></Headline>
                <LinkButtonContainer>
                  <a href={item.link.url} target="_blank" rel="noopener noreferrer"><img src={outboundLinkUrl} /></a>
                </LinkButtonContainer>
              </HeadlineLinkContainer>
            </ArticleContainer>
          );
        })}
      </ArticleListInner>
    </ArticleListContainer>
  );
}

export { ArticleListSection };
